export default __webpack_public_path__ + "static/media/smartobject_circles.33fe49f0.png";